import styled from 'styled-components'
import OboroImg from './img/oboro-chibi.png'
import PetalsGif from './img/petals-animated-gif.gif'
import GreenLeaf from './img/green-leaf.png'
import BgImgSocialMedia1 from './img/video_chat.png'
import BgImgSocialMedia2 from './img/icons8-logo-discord-30.png'
import BgImgSocialMedia3 from './img/icons8-instagram-24.png'
import BgImgSocialMedia4 from './img/icons8-facebook-novo-30.png'
import Tooltip from '../Tooltip/Tooltip'
import { TipMouseOutEvent, TipMouseOverEvent } from '../Tooltip/Tooltip'
import { useContext, useEffect} from 'react'
import { PageContext } from '../Context/PageContext'
import { WavSoundEffect } from '../WavSoundEffects/WavSoundEffects'


function Banner() {

  const { isLogged, user, noticeMessage, setNoticeMessage, flyingpetImage } = useContext(PageContext);

  function LoginMessage(){
    
    if(!isLogged) {
    setNoticeMessage( `Seja bem vindo visitante! Clique na seção de cadastro e junte-se a nós! `);
    return;
    }

    setNoticeMessage( `Olá ${user.userName}! É um prazer vê-lo novamente obrigado por escolher nosso servidor ♥ `);
  }

  useEffect(LoginMessage,[]);

    return (
        <BannerText>
          <PetalsAnimated/>
          <OboroIcon/>
          
          <FlyingPet backgroundPet={flyingpetImage} 
          onMouseOver={(event) => {
            TipMouseOverEvent(event, "Buzz..Buzz<br>(Não Clique!)","rgb(33, 33, 33)");
            WavSoundEffect('/wav/chocho_stand.wav', ' ', 'hover')}}
          onMouseLeave={() => TipMouseOutEvent()}
          onClick={() => WavSoundEffect(' ', '/bgm/12.mp3', 'click')}/>
  
          <Leaf/>

          <SocialMediaContainer>
            <style>{css}</style>
            <SocialMedia 
            onMouseOver={(event) => TipMouseOverEvent(event, "Youtube Channel","rgb(33, 33, 33)")}
            onMouseLeave={() => TipMouseOutEvent()}
            bgcolorsocialmedia="#F44336"
            bgimgsocialmedia={BgImgSocialMedia1} width={'40px'} height={'40px'}
            className="AnimationRed" />

            <SocialMedia
            onMouseOver={(event) => TipMouseOverEvent(event,"Discord","rgb(33, 33, 33)")}
            onMouseLeave={() => TipMouseOutEvent()}
            onClick={() => window.open('https://discord.gg/X8Z2gVQ93K', "_blank")}
            bgcolorsocialmedia= "#FDD835"
            bgimgsocialmedia={BgImgSocialMedia2} width={'40px'} height={'40px'}
            className="AnimationYellow"/>

            <SocialMedia
            onMouseOver={(event) => TipMouseOverEvent(event,"Instagram", "rgb(33, 33, 33)")}
            onMouseLeave={() => TipMouseOutEvent()}
            onClick={() => window.open('https://www.instagram.com/lionsragnarokprivate/', "_blank")}
            bgcolorsocialmedia="#4CAF50"
            bgimgsocialmedia={BgImgSocialMedia3} width={'40px'} height={'40px'}
            className="AnimationGreen"/>

            <SocialMedia
            onMouseOver={(event) => TipMouseOverEvent(event,"Facebook","rgb(33, 33, 33)")}
            onMouseLeave={() => TipMouseOutEvent()}
            onClick={() => window.open('https://www.facebook.com/LionsRagnarok/', "_blank")}
            bgcolorsocialmedia="#2196F3"
            bgimgsocialmedia={BgImgSocialMedia4} width={'40px'} height={'40px'}
            className="AnimationBlue"/>

          </SocialMediaContainer>

          <Title>
            <GreenText>LIONS</GreenText>
            <BlueText>RAG</BlueText>
          </Title>
          <Hr />
          <SubTitle>Private Ragnarok Online</SubTitle>
        </BannerText>
    );

  
};


const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 100px;
  margin-bottom: 50px;
  //border: solid, 2px black;
  width: 640px;
  transition: .3s ease-in-out;
  position: relative;

  @media(max-width: 1000px) {
  scale: .6;
  margin-bottom: 10px;
  margin-top: 70px;
  }
  
`;

const NoticeWelcome = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid;
  width: 350px;
  border-radius: 10px;
  padding: 10px 10px;
  background-color: rgb(0, 0, 0);
  opacity: .3;
  color: white;
  text-align: center;
  margin-top: -10px;
  margin-left: 100px;
  transition: .3s ease-in-out;
  z-index: 3;
  cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

  &:hover {
  opacity: 1;
  transform: translate(-2px, -2px)
  }
`

const PetalsAnimated = styled.div`
  background: url(${PetalsGif});
  background-size: cover;
  width: 298px;
  height: 390px;
  z-index: 2;
  position: absolute;
  margin-left: 8px;
`;

const OboroIcon = styled.div`
  background: url(${OboroImg});
  background-size: cover;
  background-color: white;
  width: 238px;
  height: 330px;
  z-index: 1;
  position: absolute;
  left: 23px;
  top: 0px;
`;

const FlyingPet = styled.div`
  background: url(${props => props.backgroundPet});
  background-size: cover;
  background-color: white;
  width: 37px;
  height: 35px;
  z-index: 1;
  position: absolute;
  right: -110px;
  top: 100px;

  cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

  @media (max-width: 1000px) {
    right: 0px;
    top: -40px;
    }
`;

const Leaf = styled.div`
  background: url(${GreenLeaf});
  background-size: cover;
  margin-left: 513px;
  margin-top: 333px;
  opacity: 0;
  transform: rotate(160deg);
  width: 50px;
  height: 25px;
  z-index: 2;
  position: absolute;
`;

const Title = styled.h1`
  margin: 115px 0px -15px 0px;
  padding: 0;
  font-size: 75px;
  text-align: center;
  z-index: 2;
  letter-spacing: 0.3rem;

`;

const GreenText = styled.span`
  color: rgb(21, 167, 8);
  font-size: 104px;
  -webkit-text-stroke: 1px white;
  font-weight: bolder;
  font-family: Arial;
  cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    filter: saturate(200%);
    transition: 1s  ease-in-out;
    }

    &:not(:hover) {
    filter: saturate(100%);
    transition: .2s  ease-in-out;
    }
`;

const BlueText = styled.span`
  color:rgb(33, 119, 240);
  font-size: 100px;
  -webkit-text-stroke: 1px white;
  font-weight: bolder;
  font-family: Arial;

  cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

   &:hover {
    filter: saturate(400%);
    transition: 1s  ease-in-out;
    }

    &:not(:hover) {
    filter: saturate(100%);
    transition: 1s  ease-in-out;
    }
`;

const Hr = styled.hr`
  border: solid 1px rgb(33, 119, 240);
  width: 630px;
  margin: 0 auto;
`;

const SubTitle = styled.h2`
  margin: 10px 0px 0px 0px;
  padding: 0;
  font-size: 28px;
  font-weight: bold;
  font-family: Arial;
  text-align: center;
  color:rgb(33, 119, 240);
  font-style: italic;
  -webkit-text-stroke: .5px white;
  z-index: 2;
`;

const SocialMedia = styled.li`
  
  background-color: ${props => props.bgcolorsocialmedia};
  background-image: url(${props => props.bgimgsocialmedia});
  background-position: center center;
  background-repeat: no-repeat;
  width: ${props => props.width};
  height: ${props => props.height};
  margin-left: 5px;
  border-radius: 50%;
  animation-duration: 2s;
  animation-delay: 3s;
  animation-iteration-count: infinite;
  z-index: 1;

  cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

   &:hover {
    transform: scale(1.3);

   }
    transition: .3s;
`;

const SocialMediaContainer = styled.ul`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px 10px;
  right: 0;
  top: 40px;
  //border: solid 2px black;
  position: absolute;
  list-style-type: none;
  height: 50px;

  @media(max-width: 1000px) {
  scale: 1.5;
  right: 40px;
  top: 20px;
  }

`;

const css = `
  .AnimationRed {
  animation-name: pulseAnimationRed;
  }

  .AnimationYellow {
  animation-name: pulseAnimationYellow;
  }

  .AnimationGreen {
  animation-name: pulseAnimationGreen;
  }

  .AnimationBlue {
  animation-name: pulseAnimationBlue;
  }

@keyframes pulseAnimationRed {
  0% { box-shadow: 0px 0px 0px 0px rgba(244, 67, 54, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(244, 67, 54, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(244, 67, 54, 0); }
}

@keyframes pulseAnimationYellow {
  0% { box-shadow: 0px 0px 0px 0px rgba(253, 216, 53, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(253, 216, 53, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(253, 216, 53, 0); }
}

@keyframes pulseAnimationGreen {
  0% { box-shadow: 0px 0px 0px 0px rgba(76, 175, 80, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(76, 175, 80, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(76, 175, 80, 0); }
}

@keyframes pulseAnimationBlue {
  0% { box-shadow: 0px 0px 0px 0px rgba(33, 150, 243, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(33, 150, 243, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(33, 150, 243, 0); }
}
 `

export default Banner;



